import { createSlice } from "@reduxjs/toolkit";
import { allUser,addSistem,addUser,dropSistem,dropUser,editByAdmin,editSelf,editSistemOne } from "../actions/user";
import { User } from "../interfaces";

const initialState : User = {
    userAll : [],
    userOne : {},
    loadingUser : false,
    msgUser : ""
}
export const userStore = createSlice({
    name:"user",
    initialState,
    reducers : {
        clearUser : (state)=>{
            state.userAll = []
            state.msgUser = ""
        },
        clearOneUser : (state)=>{
            state.userOne = {}
            state.msgUser = ""
        }
    },
    extraReducers:builder=>{
        builder
        .addCase(allUser.pending,(state)=>{
            state.loadingUser = true
        })
        .addCase(allUser.fulfilled,(state,action)=>{
            state.loadingUser = false
            state.userAll = action.payload
        })
        .addCase(allUser.rejected,(state,action)=>{
            state.loadingUser = false
            state.msgUser = action.payload?.message
        })
        .addCase(addUser.pending,(state)=>{
            state.loadingUser = true
        })
        .addCase(addUser.fulfilled,(state,action)=>{
            state.loadingUser = false
            state.msgUser = action.payload.msg
        })
        .addCase(addUser.rejected,(state,action)=>{
            state.loadingUser = false
            state.msgUser = action.payload?.message
        })
        .addCase(editSelf.pending,(state)=>{
            state.loadingUser = true
        })
        .addCase(editSelf.fulfilled,(state,action)=>{
            state.loadingUser = false
            state.msgUser = action.payload.msg
        })
        .addCase(editSelf.rejected,(state,action)=>{
            state.loadingUser = false
            state.msgUser = action.payload?.message
        })
        .addCase(editByAdmin.pending,(state)=>{
            state.loadingUser = true
        })
        .addCase(editByAdmin.fulfilled,(state,action)=>{
            state.loadingUser = false
            state.msgUser = action.payload.msg
        })
        .addCase(editByAdmin.rejected,(state,action)=>{
            state.loadingUser = false
            state.msgUser = action.payload?.message
        })
        .addCase(dropUser.pending,(state)=>{
            state.loadingUser = true
        })
        .addCase(dropUser.fulfilled,(state,action)=>{
            state.loadingUser = false
            state.msgUser = action.payload.msg
        })
        .addCase(dropUser.rejected,(state,action)=>{
            state.loadingUser = false
            state.msgUser = action.payload?.message
        })
        .addCase(addSistem.pending,(state)=>{
            state.loadingUser = false
        })
        .addCase(addSistem.fulfilled,(state,action)=>{
            state.loadingUser = false
            state.msgUser = action.payload.msg
        })
        .addCase(addSistem.rejected,(state,action)=>{
            state.loadingUser = false
            state.msgUser = action.payload?.message
        })
        .addCase(dropSistem.pending,(state)=>{
            state.loadingUser = false
        })
        .addCase(dropSistem.fulfilled,(state,action)=>{
            state.loadingUser = false
            state.msgUser = action.payload.msg
        })
        .addCase(dropSistem.rejected,(state,action)=>{
            state.loadingUser = false
            state.msgUser = action.payload?.message
        })
        .addCase(editSistemOne.pending,(state)=>{
            state.loadingUser = false
        })
        .addCase(editSistemOne.fulfilled,(state,action)=>{
            state.loadingUser = false
            state.msgUser = action.payload.msg
        })
        .addCase(editSistemOne.rejected,(state,action)=>{
            state.loadingUser = false
            state.msgUser = action.payload?.message
        })
    }
})
export const userActions =userStore.actions
export default userStore.reducer